module.exports = __webpack_public_path__ + "img/0fc905d.png";